import { api } from "@/lib/api";

export interface Email {
  id: string;
  subject: string | null;
  from_email: string | null;
  to_emails: string[];
  cc_emails: string[];
  bcc_emails: string[];
  timestamp: string;
  body: string | null;
  source_record_reply_idx: number;
  direction: string;
}

export interface ThreadSummary {
  thread_id: string;
  active_participants: string[];
  all_participants: string[];
  number_of_messages: number;
  first_message_date: string;
  last_message_date: string;
  subject: string | null;
}

export interface EmailThread {
  thread_summary: ThreadSummary;
  emails: Email[];
}

export function useEmailThread(emailId: string | null) {
  return api.useQuery<EmailThread>(`datahub/emails/${emailId}/thread/`, {
    enabled: !!emailId,
  });
}
